export default {
    tableClass: 'table table-striped table-bordered table-hover',
    loadingClass: 'loading',
    ascendingIcon: 'glyphicon glyphicon-chevron-up',
    descendingIcon: 'glyphicon glyphicon-chevron-down',
    handleIcon: 'glyphicon glyphicon-menu-hamburger',
    pagination: {
        infoClass: 'pull-left',
        wrapperClass: 'vuetable-pagination pull-right',
        activeClass: 'btn-primary',
        disabledClass: 'disabled',
        pageClass: 'btn btn-border',
        linkClass: 'btn btn-border',
        icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
        },
    },
}


// WEBPACK FOOTER //
// ./src/components/Communs/cssBootstrap-css.js